import { defineComponent, onMounted, onUnmounted, watch } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import SearchDropdown
	from '@/presentation/components/organisation-linking/organisation-linking-search/search-dropdown/search-dropdown.vue';
import SearchInputCode from '@/presentation/components/organisation-linking/organisation-linking-search/search-input.code';
import DateStart from '@/presentation/components/campaign-settings/date-start/date-start';
import DateEnd from '@/presentation/components/campaign-settings/date-end/date-end';

export default defineComponent({
	components: {
		DateEnd, DateStart,
		LoadingWrapper,
		SearchDropdown
	},
	setup: () => {
		const code = new SearchInputCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		watch(code.linkedOrganisationsAsString, code.resetDropdown.bind(code));

		return {
			isLoading: code.isLoading,
			searchResultsAsString: code.searchResultsAsString,
			linkedOrganisationsAsString: code.linkedOrganisationsAsString,
			searchWrapper: code.searchWrapper,
			searchTerm: code.searchTerm,
			searchInput: code.searchInput,
			searchResults: code.searchResults,
			showSpinner: code.showSpinner,
			showDropdown: code.showDropdown,
			setSearchTerm: code.setSearchTerm.bind(code),
			revealDropdown: code.revealDropdown.bind(code)
		};
	}
});
